import 'slick-carousel'
import jQuery from 'jquery'

class Slider {
    constructor (theme, elem) {
        this.elem = elem
        this.options = Object.assign({
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: true,
            draggable: true,
            slidesToShow: 1,
            mobileOnly: false,
            swipe: true,
            dontInit: false,
            showAbove: null,
            showBelow: null
        }, JSON.parse(this.elem.dataset.options))

        if (this.options.mobileOnly) {
            this.options.showBelow = 769
        }

        if (!this.options.dontInit) {
            this.init()
        }
    }

    onInit () {
    }

    init () {
        if (this.options.showAbove && window.innerWidth <= this.options.showAbove) {
            return false
        }

        if (this.options.showBelow && window.innerWidth >= this.options.showBelow) {
            return false
        }

        jQuery(this.elem).on('init', (e, slick) => {
            this.elem.dispatchEvent(new Event('sliderRendered'))
            let vid = slick.$slides.length ? slick.$slides[0].querySelector('video') : false
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
        })

        jQuery(this.elem).not('.slick-initialized').slick(this.options)

        jQuery(this.elem).on('beforeChange', (e, slick, curSlide, nextSlide) => {
            let vid = slick.$slides[curSlide].querySelector('video')
            if (vid) {
                vid.pause()
            }
        })

        jQuery(this.elem).on('afterChange', (e, slick, curSlide) => {
            let vid = slick.$slides[curSlide].querySelector('video')
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
        })
    }
}

export default Slider



// WEBPACK FOOTER //
// ./resources/scripts/components/Slider.js